import React, { useEffect, useState } from 'react'
import { Model } from '../../models/model'
import moment from 'moment'

export const Actividad = () => {

    const [logs, setLogs] = useState([])

    useEffect(() => {
        getLogs()
    }, [])

    const getLogs = async () => {
        const results = await Model.getAll({
            url: 'ajustes/logs'
        })

        console.log({ results })
        setLogs(results || [])
    }

    return (
        <div className='container'>

            <div className="row p-contet-title-info-personal">
                <div className="col-12">
                    <h3 className='text-start p-title-info-personal'>Registro de actividad</h3>
                </div>
                <div className="col-12 p-text-info-personal">
                    <h6>Registro de actividades principales</h6>
                </div>
            </div>

            <div className='mt-4'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th className='text-center'>Usuario</th>
                            <th className='text-center'>Módulo</th>
                            <th className='text-center'>Fecha (hoy)</th>
                            <th className='text-start'>Accion</th>
                            <th className='text-start'>Plataforma</th>
                        </tr>
                    </thead>
                    <tbody>
                        {logs?.map(it => (
                            <tr key={it.id} style={{ fontSize: '14px' }}>
                                <td className='text-center' style={{ textTransform: 'lowercase' }}>{it?.login || '---'}</td>
                                <td className='text-center'>{(it?.modulo === 'negocios' ? 'proyectos' : it?.modulo) || '---'}</td>
                                <td className='text-center'>{`${moment(it?.fecha).format('DD-MM-YY LT')}` || '---'}</td>
                                <td className='text-start' style={{ textTransform: 'lowercase' }}>{it?.accion || '---'}</td>
                                <td className='text-start' style={{ textTransform: 'lowercase' }}>{it?.plataforma || '---'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

        </div>
    )
}
